//课件url前置
export const COURSE_URL = '/pay';

export const ROUND_NAME = {
    '1': 'carriage',
    '2': 'archery',
    '3': 'castle',
    '4': 'castle'
};



// WEBPACK FOOTER //
// ./src/constants.js